import React from 'react';
import PropTypes from 'prop-types';

const ReportTitle = props => {
    return <h1>ReportTitle</h1>;
};

ReportTitle.propTypes = {
    settings: PropTypes.object,
    isPreview: PropTypes.bool,
};

export default ReportTitle;
